var exports = {
  "O7": "SplitPageLayout__MF76uh",
  "Ku": "SplitPageLayout_Content__9CAaEg",
  "EK": "searchResultsPage__V_VaJW",
  "V2": "searchResultsPageWithErrors__Kq66GU",
  "_s": "paginationWrapper__JGJOO_",
  "zz": "dataResults__0hn5iX",
  "PM": "dataResultsFullHeight__HlccPB",
  "k8": "twoColumnOuter__y0eBQT",
  "If": "twoColumnOuterFullHeight__MgRv1B",
  "Em": "mainColumn__3vDPrA",
  "ED": "mainColumnFullHeight__okjtQ4",
  "PP": "noticesContainer__aSCPU0",
  "dv": "primarySuggestionMobile__xm8KQB",
  "Tn": "columnLeftWrapper__NbOS37",
  "jm": "columnLeftWrapperFullHeight__P5fXOr",
  "y4": "paginationSection__CAqCDv",
  "f2": "secondarySuggestionMobile__JeRfDn",
  "VP": "rightSidebar__de2EcP",
};

module.exports = exports;
